const listChecklistItem = {
  primary: 'Seção sem Perguntas'
};

export default listChecklistItem;
